import React from 'react';
import ReactTooltip from 'react-tooltip';
import { addMinutes, differenceInHours, differenceInMinutes, format, startOfToday } from 'date-fns';
import { ColContainer, Typography } from '../../../components/common';

export const TableTooltip = () => {
    return (
        <ReactTooltip
            id="table"
            backgroundColor="#63686B"
            place="bottom"
            getContent={(dataTip) => {
                const data = JSON.parse(dataTip);
                if (data == null) return <></>;

                const startTime = addMinutes(startOfToday(), data.start);
                const endTime = addMinutes(startOfToday(), data.end);
                const timeDiff =
                    differenceInMinutes(endTime, startTime) < 60
                        ? `${differenceInMinutes(endTime, startTime)} minutes`
                        : `${differenceInHours(endTime, startTime)} hours`;

                return (
                    <ColContainer spacing="small">
                        <Typography variant="heading2.2" className="capitalize">
                            {data.schedule}
                        </Typography>
                        <ColContainer>
                            <Typography variant="heading2.2">
                                {format(startTime, 'kk:mm')} - {format(endTime, 'kk:mm')}
                            </Typography>
                            {/* Check if the value is negative and don't display if so. This is for items that are carried over from
                        the previous day as they will display as negative values in minutes */}
                            {Math.sign(differenceInMinutes(endTime, startTime)) !== -1 ? (
                                <Typography variant="body3">{timeDiff}</Typography>
                            ) : null}
                        </ColContainer>
                        <ColContainer>
                            <Typography variant="heading2.2">
                                {data.company} ({data.project})
                            </Typography>
                            <Typography variant="body3">{data.label}</Typography>
                        </ColContainer>
                    </ColContainer>
                );
            }}
        />
    );
};
